module.exports = __webpack_public_path__ + "static/Implants bridge smile before-fa41cb717f97dfa1121a321aa479c9af.jpg";